import { BASE_URL } from "../environment";

export const ADMIN_LOGIN_URL = `${BASE_URL}/admin-login/`;
export const GET_ALL_USER_DATA = `${BASE_URL}/users`;
export const GET_USER_DETAILS = `${BASE_URL}/user`;
export const ADD_USER_DETAILS = `${BASE_URL}/user`;
export const DELETE_USER_DETAILS = `${BASE_URL}/user`;
export const UPDATE_USER_PROFILE = `${BASE_URL}/user/update-admin-profile`;
export const CHANGE_PASSWORD = `${BASE_URL}/change-password`;
export const FORGOT_PASSWORD = `${BASE_URL}/forgot-password`;
export const RESET_PASSWORD = `${BASE_URL}/reset-password`

export const USER_DETAILS_URL = `${BASE_URL}/get_profile`;
export const UPDATE_PROFILE_PIC = `${BASE_URL}/udpate_profile_pic/`;

export const GET_ALL_POSTS = `${BASE_URL}/posts`;
export const CREATE_POST = `${BASE_URL}/post`;
export const DELETE_POST = `${BASE_URL}/posts`;
export const GET_FLAGGED_POSTS = `${BASE_URL}/posts/flagged/list`;
export const APPROVE_POST = `${BASE_URL}/posts`;
export const BLOCK_POST = `${BASE_URL}/posts`;
export const GET_BLOCKED_USERS = `${BASE_URL}/users/blocked/list`;
export const BLOCK_USER = `${BASE_URL}/user`;
export const UNBLOCK_USER = `${BASE_URL}/user`;

export const GET_ADMIN_DASHBOARD_SUMMARY = `${BASE_URL}/admin/dashboard/summary`;
export const GET_USER_DASHBOARD_SUMMARY = `${BASE_URL}/dashboard/summary`;

/**
 * Analytics endpoints (admin)
 */
export const GET_USERS_OVER_TIME = `${BASE_URL}/admin/analytics/users-over-time`;
export const GET_REVENUE_OVER_TIME = `${BASE_URL}/admin/analytics/revenue-over-time`;
export const GET_MOOD_TRENDS = `${BASE_URL}/admin/analytics/mood-trends`;
export const GET_JOURNAL_ENTRIES_OVER_TIME = `${BASE_URL}/admin/analytics/journal-entries-over-time`;
export const GET_COMMUNITY_POSTS_OVER_TIME = `${BASE_URL}/admin/analytics/community-posts-over-time`;

export const GET_TERMS_AND_CONDITIONS = `${BASE_URL}/legal/terms`;
export const GET_PRIVACY_POLICY = `${BASE_URL}/legal/privacy`;
export const GET_HELP_SUPPORT = `${BASE_URL}/legal/help`;
export const GET_CONSENT = `${BASE_URL}/legal/consent`;
export const GET_ALL_LEGAL = `${BASE_URL}/legal/all`;
export const CREATE_OR_UPDATE_LEGAL = `${BASE_URL}/legal/create-update`;

// Subscription endpoints
export const GET_SUBSCRIPTION_HISTORY = `${BASE_URL}/users/subscription/history`;
export const GET_ONGOING_SUBSCRIPTION = `${BASE_URL}/users/subscription/ongoing`;

export const GET_DROPDOWN = `${BASE_URL}/dropdowns`;
export const UPDATE_DROPDOWN = `${BASE_URL}/dropdowns`;

// Newsletter endpoints
export const GET_NEWSLETTER_SUBSCRIBERS = `${BASE_URL}/newsletter/list`;
export const UNSUBSCRIBE_NEWSLETTER = `${BASE_URL}/newsletter/unsubscribe`;